var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('article',{staticClass:"container-fluid"},[_c('h1',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.$t("alerts.title")))]),_c('alerts-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }